import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const FacturasHistorial = () => {
  const axiosPrivate = useAxiosPrivate();
  const [facturas, setFacturas] = useState([]);

  useEffect(() => {
    const load = async () => {
      const res = await axiosPrivate.get("CEUM/facturas");
      setFacturas(res.data);
    };
    load();
  }, []);
  const descargarXML = async (id) => {
    const res = await axiosPrivate.get(`CEUM/facturas/${id}/xml`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", `factura_${id}.xml`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  const descargarPDF = async (id) => {
    const res = await axiosPrivate.get(`CEUM/facturas/${id}/pdf`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement("a");

    link.href = url;
    link.download = "factura.pdf";
    link.click();
  };

  return (
    <DataTable value={facturas} paginator rows={10}>
      <Column field="id" header="ID" />
      <Column field="matricula" header="Alumno" />
      <Column field="uuid" header="UUID" />
      <Column field="total" header="Total" />
      <Column field="estatus" header="Estatus" />

      <Column
        header="XML"
        body={(row) => (
          <Button icon="pi pi-download" onClick={() => descargarXML(row.id)} />
        )}
      />

      <Column
        header="PDF"
        body={(row) => (
          <Button icon="pi pi-file-pdf" onClick={() => descargarPDF(row.id)} />
        )}
      />
    </DataTable>
  );
};

export default FacturasHistorial;
